import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { CreatePromoCodeDto, CreatePromoCodeResponse, DeletePromoCodeResponse, UpdatePromoCodeDto } from "src/app/pages/onlinestore/promo-code/promo-code.interface";
import { ApiService } from "src/app/services/api";
import { AppState } from "src/app/store/app.state";
import { AlertService } from "../AlertService/alert.service";
@Injectable({
  providedIn: "root",
})
export class OnlineStoreServiceService {
  GLOBALURL = this.ApiService.getBaseURL()
  toastService: any;
  router: any;
  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private cookieService: CookieService,
    private toastr: AlertService,
    private ApiService: ApiService
  ) {}

  getTimezone() {
    var headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    const httpOptions = {
      headers: new HttpHeaders(headerToken),
    };
    return this.http
      .get<any>(this.GLOBALURL + "/timezones", httpOptions)
      .pipe(shareReplay(1));
  }

  getStoreById(): Observable<any> {
    var id = this.cookieService.get("storeId");
    var headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    const httpOptions = {
      headers: new HttpHeaders(headerToken),
    };
    if (id == '*') {
      return this.http
      .get<any>(this.GLOBALURL + `/store`, httpOptions)
      .pipe(shareReplay(1));
    } else {
      return this.http
      .get<any>(this.GLOBALURL + `/store?storeId=` + id, httpOptions)
      .pipe(shareReplay(1));
    }
  }
  getCurrentStoreById(storeId: any): Observable<any> {
    // var id = this.cookieService.get("storeId");
    var headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    const httpOptions = {
      headers: new HttpHeaders(headerToken),
    };
      return this.http
      .get<any>(this.GLOBALURL + `/store?storeId=` + storeId, httpOptions)
      .pipe(shareReplay(1));
  }

  updateStoreInfo(devicePayload): Observable<any> {
    var headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    const httpOptions = {
      headers: new HttpHeaders(headerToken),
    };

    // for store location it will load store from prod url
    // store will not fetch from preprod env
    return this.http.put<any>(
      this.GLOBALURL + "/store",
      devicePayload,
      httpOptions
    )
  }

  getOnlineStoreSettings() {
    var id = this.cookieService.get("storeId");
    var headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    const httpOptions = {
      headers: new HttpHeaders(headerToken),
    };
    return this.http
      .get<any>(this.GLOBALURL + "/settings?storeId=" + id, httpOptions)
      .pipe(shareReplay(1));
  }
  updateOnlineStoreSettings(settings): Observable<any> {
    var headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    const httpOptions = {
      headers: new HttpHeaders(headerToken),
    };
    return this.http.put<any>(
      this.GLOBALURL + "/settings",
      settings,
      httpOptions
    );
  }
  getRevenueCenters() {
    var id = this.cookieService.get("storeId");
    var headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    const httpOptions = {
      headers: new HttpHeaders(headerToken),
    };
    return this.http
      .get<any>(this.GLOBALURL + "/revenueCenter?storeId=" + id, httpOptions)
      .pipe(shareReplay(1));
  }
  getEmployee() {
    var id = this.cookieService.get("storeId");
    var headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    const httpOptions = {
      headers: new HttpHeaders(headerToken),
    };
    return this.http
      .get<any>(this.GLOBALURL + "/employee?storeId=" + id, httpOptions)
      .pipe(shareReplay(1));
  }


  getStoreFrontRegistration() {
    var storeId = this.cookieService.get("storeId");
    var merchantId = this.cookieService.get("merchantId");
    var headerToken = {
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    };
    const httpOptions = {
      headers: new HttpHeaders(headerToken),
    };
    return this.http
      .get<any>(this.GLOBALURL + `/storefront/registration?storeId=${storeId}&merchantId=${merchantId}`, httpOptions)
      .pipe(shareReplay(1));
  }



  getSupportTickets(storeId, offset, limit, merchantId,startDate,endDate): Observable<any> {
    return this.http.get(this.GLOBALURL +
        `/issues?offset=${offset}&limit=${limit}&storeId=${storeId}&merchantId=${merchantId}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: this.cookieService.get("token"),
          }),
        }
    )
  }

  getSupportTicketsForSelectedDates(storeId, offset, limit, merchantId, startDate, endDate): Observable<any> {
    return this.http.get(this.GLOBALURL +
        `/issues?offset=${offset}&limit=${limit}&storeId=${storeId}&merchantId=${merchantId}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: this.cookieService.get("token"),
          }),
        }
    )
  }

  getPaymentByItsOrderId(orderId, merchantId, storeId): Observable<any> {
    return this.http.get(this.GLOBALURL +
        `/payment?merchantId=${merchantId}&storeId=${storeId}&orderId=${orderId}`,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: this.cookieService.get("token"),
          }),
        }
    )
}

closeSupportTicket(issueId: string, issueStatus = 1): Observable<any> {
    return this.http.put( this.GLOBALURL +
        `/issues`, {issueId, issueStatus},
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: this.cookieService.get("token"),
          }),
        }
    )
}

fullRefundOrder(params): Observable<any> {
    return this.http.post<any>( this.GLOBALURL +
        '/payment/refund',
        params,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: this.cookieService.get("token"),
          }),
        }
    )
}

  uploadImage(type, formData) {
    return this.http.put(
      `${this.GLOBALURL}/upload?path=images/${type}/`,
      formData,
      {
        headers: new HttpHeaders({
          enctype: "multipart/form-data",
          // "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      }
    );
  }

  createPromoCode(payload: CreatePromoCodeDto): Observable<CreatePromoCodeResponse> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    });

    return this.http.post<CreatePromoCodeResponse>(`${this.GLOBALURL}/promo`, payload, { headers });
  }

  updatePromoCode(payload: UpdatePromoCodeDto): Observable<CreatePromoCodeResponse> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: this.cookieService.get("token"),
    });

    return this.http.put<CreatePromoCodeResponse>(`${this.GLOBALURL}/promo`, payload, { headers });
  }

  deletePromoCode(promoCodeId, isPermanent): Observable<DeletePromoCodeResponse> {
    const headers = new HttpHeaders(this.cookieService.get("token"));
    const params = new HttpParams().set('isPermanent', isPermanent.toString());
    const body = { promoCodeId };

    const httpOptions = {
      headers,
      params,
      body
    };

    return this.http.delete<DeletePromoCodeResponse>(`${this.GLOBALURL}/promo`, httpOptions);
  }

  unarchivePromoCode(id: string): Observable<any> {
    const headers = new HttpHeaders(this.cookieService.get("token"));
    const payload = {
      id: id,
      status: 1
    };

    return this.http.put(`${this.GLOBALURL}/promo`, payload, { headers });
  }

  deletePromoCodePermanent(promoCodeId, isPermanent): Observable<any> {
    const headers = new HttpHeaders(this.cookieService.get("token"));
    const params = new HttpParams().set('isPermanent', isPermanent.toString());
    const body = { promoCodeId };

    const httpOptions = {
      headers,
      params,
      body
    };

    return this.http.delete<DeletePromoCodeResponse>(`${this.GLOBALURL}/promo`, httpOptions);
  }

}
